import { useLateSubmissionCounts } from "components/materials/section/assessment/hooks";
import { t } from "i18n/i18n";
import { Card } from "mds/components/Card";
import { SquareButton } from "mds/components/buttons/SquareButton";
import { ClockIcon } from "mds/icons";
import { useAppSelector } from "store/index";
import { selectCurrentSectionId } from "store/selectors";
import { Link } from "utils/routing";
import { sectionHomeUrl } from "utils/urls";

export const LateSubmissionCard = () => {
  const currentSectionId = useAppSelector(selectCurrentSectionId);
  const { totalLateCount, newLateCount } = useLateSubmissionCounts();

  if (totalLateCount === 0) return null;

  return (
    <Card className="my-3 flex flex-row items-center justify-between pl-5 pr-4" small>
      <div className="flex flex-row items-center justify-center gap-2">
        <div className="flex h-6 w-6 items-center justify-center rounded-full bg-orange-tint-90">
          <ClockIcon className="text-orange-shade-20" />
        </div>
        <div className="text-sm font-normal text-black-tint-20">
          {t("section.sidebar.planner.late_submissions", { count: totalLateCount })}
        </div>
      </div>
      <div className="flex flex-row items-center justify-center gap-2">
        {newLateCount > 0 && (
          <div className="text-xs font-semibold text-orange-shade-20">
            {t("section.sidebar.planner.new", { count: newLateCount })}
          </div>
        )}
        <SquareButton
          as={Link}
          kind="secondary"
          size="xs"
          to={`${sectionHomeUrl(currentSectionId)}?tab=assessments`}
        >
          {t("common.view")}
        </SquareButton>
      </div>
    </Card>
  );
};
